// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class HubSearchAccountsRequestModel {
    static getAttributeTypeMap() {
        return HubSearchAccountsRequestModel.attributeTypeMap;
    }
}
HubSearchAccountsRequestModel.discriminator = undefined;
HubSearchAccountsRequestModel.attributeTypeMap = [
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "dateOfBirth",
        "baseName": "dateOfBirth",
        "type": "Date"
    },
    {
        "name": "city",
        "baseName": "city",
        "type": "string"
    },
    {
        "name": "state",
        "baseName": "state",
        "type": "string"
    },
    {
        "name": "zip",
        "baseName": "zip",
        "type": "string"
    },
    {
        "name": "gender",
        "baseName": "gender",
        "type": "Gender"
    },
    {
        "name": "externalId",
        "baseName": "externalId",
        "type": "string"
    },
    {
        "name": "accountExternalIdType",
        "baseName": "accountExternalIdType",
        "type": "AccountExternalIdType"
    }
];
//# sourceMappingURL=hubSearchAccountsRequestModel.js.map